import * as amplitude from "amplitude-js";

if (window.appConfig.amplitude.isEnabled) {
  amplitude.getInstance().init(window.appConfig.amplitude.key);
  amplitude.getInstance().setUserProperties({
    is_webview: window.clientConfig.isWebview,
    platform_browser_name: window.clientConfig.platform.name,
    platform_browser_version: window.clientConfig.platform.version,
    platform_os: window.clientConfig.platform.os,
  });
}

// --

export const userEvents = {
  // получили событие webiew_tab_selected от нативного приложения
  // параметры:
  // os: android, ios или other
  WEBVIEW_TAB_FOCUS: "webview_tab_focus",

  // визит на главную страницу
  PAGE_INDEX: "page_index",

  // визит на страницу результата
  // параметры:
  // photo_id (наш идентификатор фото)
  // is_owner (владелец/реферал)
  // ref (канал шаринга или unspecified)
  PAGE_RESULT: "page_result",

  // юзер нажал на "попробовать другое фото"
  // параметры: page (страница: create, result, error)
  HOME_BUTTON_CLICK: "home_button_click",

  // юзер выбрал фото
  // параметры: page (страница: index, error, result)
  PHOTO_SELECT: "photo_select",

  // юзер успешно загрузил фото
  PHOTO_UPLOADED: "photo_uploaded",

  // юзер неуспешно загрузил фото
  PHOTO_UPLOAD_FAILED: "photo_upload_failed",

  // успешно закончился процессинг всех обработок
  // elapsed_time_ms (время затраченое юзером на ожидание с момент загрузки фото, в миллисекундах)
  PROCESSING_PROCESSED: "processing_processed",

  // неуспешно закончился процессинг всех обработок
  // elapsed_time_ms (время затраченое юзером на ожидание с момент загрузки фото, в миллисекундах)
  PROCESSING_FAILED: "processing_failed",

  // параметры:
  // group (группа креативов)
  // default_group (группа креативов выбранная при загрузке страницы)
  // refreshes (сколько раз был нажат рефреш)
  GROUP_REFRESH: "group_refresh",

  // юзер кликнул на кнопку скачать
  // параметры:
  // photo_id (наш идентификатор фото)
  // collage_template_id (наш идентификатор шаблона)
  // group (группа креативов)
  // default_group (группа креативов выбранная при загрузке страницы)
  // refreshes (сколько раз был нажат рефреш)
  DOWNLOAD: "download",
};

export const hits = {};

export function hitEvent(id) {
  if (window.appConfig.isDebug) {
    console.info("hitEvent", id);
  }

  if (window.appConfig.hits.isEnabled) {
    window.axios.post(`${window.appConfig.hits.endpoint}?id=${id}&r=${Date.now()}`)
      .then(() => {/* dummy */})
      .catch(console.error);
  }
}

export function logEvent(eventId, eventParams, cb) {
  if (window.appConfig.isDebug) {
    console.info("logEvent", eventId, eventParams);
  }

  logAmplitude(eventId, eventParams, cb);

  if (window.appConfig.analytics.isEnabled) {
    window.axios.post(window.appConfig.analytics.endpoint, {id: eventId, params: eventParams})
      .then(() => {/* dummy */})
      .catch(console.error);
  }
}

export function logAmplitude(eventId, eventParams, cb) {
  if (window.appConfig.amplitude.isEnabled) {
    amplitude.getInstance().logEvent(eventId, eventParams || {}, cb);
  }
}